export const makersOptionsDict = {
	ja: [
		{ value: '1', label: 'Vestas' },
		{ value: '2', label: 'Siemens' },
		{ value: '3', label: 'HITACHI' },
		{ value: '4', label: 'ENERCON' },
		{ value: '5', label: 'GE' },
		{ value: '6', label: 'Gamesa' },
		{ value: '0', label: 'その他' },
	],
	en: [
		{ value: '1', label: 'Vestas' },
		{ value: '2', label: 'Siemens' },
		{ value: '3', label: 'HITACHI' },
		{ value: '4', label: 'ENERCON' },
		{ value: '5', label: 'GE' },
		{ value: '6', label: 'Gamesa' },
		{ value: '0', label: 'Others' },
	],
	de: [
		{ value: '1', label: 'Vestas' },
		{ value: '2', label: 'Siemens' },
		{ value: '3', label: 'HITACHI' },
		{ value: '4', label: 'ENERCON' },
		{ value: '5', label: 'GE' },
		{ value: '6', label: 'Gamesa' },
		{ value: '0', label: 'Anderer' },
	],
}

export const capacityOptionsDict = {
	ja: [
		{ value: '1', label: '1.3MW' },
		{ value: '2', label: '1.5MW' },
		{ value: '3', label: '2MW' },
		{ value: '4', label: '3MW' },
		{ value: '5', label: '5MW' },
		{ value: '0', label: 'その他' },
	],
	en: [
		{ value: '1', label: '1.3MW' },
		{ value: '2', label: '1.5MW' },
		{ value: '3', label: '2MW' },
		{ value: '4', label: '3MW' },
		{ value: '5', label: '5MW' },
		{ value: '0', label: 'Others' },
	],
	de: [
		{ value: '1', label: '1.3MW' },
		{ value: '2', label: '1.5MW' },
		{ value: '3', label: '2MW' },
		{ value: '4', label: '3MW' },
		{ value: '5', label: '5MW' },
		{ value: '0', label: 'Anderer' },
	],
}
export const devicesOptionsDict = {
	ja: [
		{ value: '2', label: '2台' },
		{ value: '4', label: '4台' },
		{ value: '6', label: '6台' },
		{ value: '8', label: '8台' },
		{ value: '12', label: '12台' },
		{ value: '0', label: 'その他' },
	],
	en: [
		{ value: '2', label: '2 units' },
		{ value: '4', label: '4 units' },
		{ value: '6', label: '6 units' },
		{ value: '8', label: '8 units' },
		{ value: '12', label: '12 units' },
		{ value: '0', label: 'Others' },
	],
	de: [
		{ value: '2', label: '2' },
		{ value: '4', label: '4' },
		{ value: '6', label: '6' },
		{ value: '8', label: '8' },
		{ value: '12', label: '12' },
		{ value: '0', label: 'Anderer' },
	],
}

export const powerOptionsDict = {
	ja: [
		{ value: '1', label: 'モータと共通', id: 'power1' },
		{ value: '2', label: 'モーターと別', id: 'power2'},
		{ value: '0', label: '不明', id: 'power3'},
	],
	en: [
		{ value: '1', label: 'Same as that for the motor', id: 'power1' },
		{ value: '2', label: 'Separate from that for the motor', id: 'power2' },
		{ value: '0', label: 'Unknown', id: 'power3' },
	],
	de: [
		{ value: '1', label: 'Mit Motor gekoppelt', id: 'power1' },
		{ value: '2', label: 'Vom Motor getrennt', id: 'power2' },
		{ value: '0', label: 'Unbekannt', id: 'power3' },

	],
}

export const currentOptionsDict= {
	ja: [
		{ value: '1', label: 'AC', id: 'current1' },
		{ value: '2', label: 'DC', id: 'current2' },
		{ value: '0', label: '不明', id: 'current3' },
	],
	en: [
		{ value: '1', label: 'AC',id: 'current1' },
		{ value: '2', label: 'DC' , id: 'current2'},
		{ value: '0', label: 'Unknown', id: 'current3'},
	],
	de: [
		{ value: '1', label: 'Wechselstrom (AC)',id: 'current1' },
		{ value: '2', label: 'Gleichstrom (DC)', id: 'current2' },
		{ value: '0', label: 'Unbekannt', id: 'current3' },
	],
}

export const kanzaOptionsDict = {
	ja: [
		{ value: '1', label: '間座あり' },
		{ value: '2', label: '間座なし' },
		{ value: '0', label: '不明' },
	],
	en: [
		{ value: '1', label: 'Included' },
		{ value: '2', label: 'Not included' },
		{ value: '0', label: 'Unknown' },
	],
	de: [
		{ value: '1', label: 'Mit Abstandshalter' },
		{ value: '2', label: 'Ohne Abstandshalter' },
		{ value: '0', label: 'Unbekannt' },
	],
}

export const methodOptionsDict = {
	ja: [
		{ value: '1', label: 'シングルサポート' },
		{ value: '2', label: 'ダブルサポート' },
		{ value: '0', label: '不明' },
	],
	en: [
		{ value: '1', label: 'Single support' },
		{ value: '2', label: 'Double support' },
		{ value: '0', label: 'Unknown' },
	],
	de: [
		{ value: '1', label: 'Einzelne Stütze' },
		{ value: '2', label: 'Doppelte Stütze' },
		{ value: '0', label: 'Unbekannt' },
	],
}

export const loadyearOptionsDict = {
	ja: [
		{ value: '1', label: '5年' },
		{ value: '2', label: '10年' },
		{ value: '3', label: '15年' },
		{ value: '4', label: '20年' },
	],
	en: [
		{ value: '1', label: '5 years' },
		{ value: '2', label: '10 years' },
		{ value: '3', label: '15 years' },
		{ value: '4', label: '20 years' },
	],
	de: [
		{ value: '1', label: '5 Jahre' },
		{ value: '2', label: '10 Jahre' },
		{ value: '3', label: '15 Jahre' },
		{ value: '4', label: '20 Jahre' },
	],
}

export const specOptionsDict = {
	ja: [
		{ label: '・監視風車設置マップ' },
		{ label: '・負荷分布図' },
		{ label: '・異常発生履歴表' },
	],
	en: [
		{ label: '・Wind turbine installation map' },
		{ label: '・Load distribution graph' },
		{ label: '・Abnormality occurrence history table' },
	],
	de: [
		{ label: '・Überwachungsplan der Windräder' },
		{ label: '・Diagramm zur Lastverteilung' },
		{ label: '・Verlaufstabelle zu Abnormalitäten' },
	],
}

export const oilDeviceBlakeOptionsDict = {
	ja: [
		{ value: '1', label: 'あり', id: 'radio1'},
		{ value: '2', label: 'なし', id: 'radio2' },
	],
	en: [
		{ value: '1', label: 'With', id: 'radio1' },
		{ value: '2', label: 'Without', id: 'radio2'},
	],
	de: [
		{ value: '1', label: 'Vorhanden', id: 'radio1' },
		{ value: '2', label: 'Nicht vorhanden', id: 'radio2' },
	],
}

